<template>
    <div class="switch">
        <div class="switch-text">
            <slot></slot>
        </div>
        <div class="switch-frame">
            <div class="switch-box" :class="{ active: active }">
                <div class="switch-button" :class="{ active: active }"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SwitchBar',
    props: ['active']
};
</script>
<style>
.switch {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    width: 100%;
}
.switch-text{
    flex-grow: 1;
    text-align: left;
    font-size: 14px;
    line-height: 20px;
}
.switch-frame {
    flex-grow: 0;
    flex-shrink: 0;
    width: 32px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.switch-box {
    width: 100%;
    height: 20px;
    border-radius: 10px;
    background-color: rgba(255,255,255,0.25);
    transition: all 300ms;
}

.switch-box.active {
    background-color: rgba(47, 135, 255, 1);
}

.switch-button {
    width: 16px;
    height: 16px;
    position: relative;
    left: 2px;
    top: 2px;
    border-radius: 16px;
    background-color: rgba(255,255,255,1);
    transition: all 300ms;
}

.switch-button.active {
    left: 14px;
    background-color: rgba(255, 255, 255, 1);

}
</style>
